import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/clinicians/photos")({
    beforeLoad: () => {
        throw redirect({ to: "/customers/clinicians", replace: true });
    },
});
